import React from 'react';
import searchParamsParser from "@Utils/searchParamsParser";
import searchParamsStringify from "@Utils/searchParamsStringify";
import stringSanitizer from "stringSanitizer";
import removeSpacesFromText from "removeSpacesFromText";

function Breadcrumbs({ breadcrumbs, data, currentRoute }) {
  let baseUrl = currentRoute && currentRoute.path ? currentRoute.path.replace(':searchParams*', '') : null;
  let searchParams = currentRoute && currentRoute.url ? searchParamsParser(currentRoute.url) : null;
  let geoData  = data && data.geoData ? data.geoData : null;
  const breadcrumbList = [];
  if (breadcrumbs && breadcrumbs.items !== undefined) {
    breadcrumbs.items.map((breadcrumb) => {
      if (breadcrumb.link !== null) {
        breadcrumbList.push(
            <li className="breadcrumb__item" key={stringSanitizer(breadcrumb.title)}>
              <a href={breadcrumb.link} className="breadcrumb__link">{breadcrumb.title.charAt(0).toUpperCase() + breadcrumb.title.slice(1)}</a>
            </li>
        );
      }
      else {
        breadcrumbList.push(
            <li className="breadcrumb__item" key={stringSanitizer(breadcrumb.title)}>{breadcrumb.title.charAt(0).toUpperCase() + breadcrumb.title.slice(1)}</li>
        );
      }
    });
  } else {
    return null;
  }
  const breadcrumbItems = {
    specialism: {
      nullValues: [
        'location',
        'type',
        'page',
        'distance'
      ],
    },
    location: {
      nullValues: [
        'type',
        'page',
        'distance'
      ],
    },
  };

  for (let paramName in breadcrumbItems) {
    if (searchParams && searchParams[paramName]) {
      if (paramName === "location" && geoData) {
        let addToBreadcrumbs = false;
        let searchParamsLocation = searchParams[paramName].split(",");
        let breadcrumbTitle = "";
        if (searchParamsLocation.length > 1) {
          searchParamsLocation[1] = searchParamsLocation[1].startsWith("-") ? searchParamsLocation[1].slice(1) : searchParamsLocation[1];
          let locationFacets = geoData && geoData.region ? geoData.region[0].split(",") : null;
          let facetValueCity = locationFacets && locationFacets.length > 1 ? removeSpacesFromText(locationFacets[0]) : null;
          let facetValueRegion = locationFacets && locationFacets.length > 1 ? removeSpacesFromText(locationFacets[1]) : null;
          let facetCityName = locationFacets && locationFacets.length > 1 ? locationFacets[0].charAt(0).toUpperCase() + locationFacets[0].slice(1) : null;
          let facetRegionName = locationFacets && locationFacets.length > 1 ? locationFacets[1].charAt(0).toUpperCase() + locationFacets[1].slice(1) : null;
          if (facetValueCity === searchParamsLocation[0] && facetValueRegion === removeSpacesFromText(searchParamsLocation[1])) {
            addToBreadcrumbs = true;
            breadcrumbTitle = `${facetCityName}, ${facetRegionName}`;
          }
        } else {
          let locationFacets = geoData && geoData.locality ? geoData.locality[0] : null;
          let facetValueCity = locationFacets ? removeSpacesFromText(locationFacets) : null;
          let facetCityName = locationFacets ? locationFacets.charAt(0).toUpperCase() + locationFacets.slice(1) : null;
          if (facetValueCity === searchParamsLocation[0]) {
            addToBreadcrumbs = true;
            breadcrumbTitle = facetCityName;
          }
        }
        if (addToBreadcrumbs) {
          let facetBuilder = Object.assign({}, searchParams);
          breadcrumbItems[paramName].nullValues.forEach(facetName => {
            facetBuilder[facetName] = null;
          });
          facetBuilder[paramName] = searchParams[paramName];
          let url = `${baseUrl}${searchParamsStringify(facetBuilder)}`;
          breadcrumbList.push(
              <li className="breadcrumb__item" key={paramName}>
                <a className="breadcrumb__link" href={url}>
                  {breadcrumbTitle}
                </a>
              </li>
          );
        }
      }
    }
  }
  // Remove the link from the last element.
  const lastElement = breadcrumbList[breadcrumbList.length-1];
  const lastElementChildren = lastElement && lastElement.props ? lastElement.props.children : [];
  if (lastElementChildren && lastElementChildren.props && lastElementChildren && lastElementChildren.props.children) {
    breadcrumbList[breadcrumbList.length-1] =  breadcrumbList.length > 1 ? React.cloneElement(lastElement, {children: lastElementChildren.props.children}) : breadcrumbList[breadcrumbList.length-1];
  }
  // Get the last but one breadcrumb element and add class to it.
  const lastButOneElement = breadcrumbList.length === 1 ? lastElementChildren : typeof (breadcrumbList[breadcrumbList.length-2].props.children) === 'object' ? breadcrumbList[breadcrumbList.length-2].props.children : breadcrumbList[breadcrumbList.length-2];
  const breadcrumbsMobile = React.cloneElement(lastButOneElement, {className: "breadcrumb__link hidden--from-l"});

  return (
      <div className="navigation__bottom">
        <nav className="breadcrumb" aria-label="breadcrumb">
          {breadcrumbsMobile}
          <ul className="breadcrumb__list hidden--until-l">
            {breadcrumbList}
          </ul>
        </nav>
      </div>
  )
}

export default Breadcrumbs;
